// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-1d46f14a],.fade-leave-active[data-v-1d46f14a]{transition:opacity .5s}.fade-enter[data-v-1d46f14a],.fade-leave-to[data-v-1d46f14a]{opacity:0}", ""]);
// Exports
module.exports = exports;
